import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import logo from '../assets/logo.png';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { t } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const closeMobile = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav id="navbar" className={isScrolled ? 'scrolled' : ''}>
        <div className="nav-logo">
          <div className="logo-icon">
            <img src={logo} alt="MSL Logo" />
          </div>
          <span>METACREATION</span>
        </div>
        <div className="nav-links">
          <Link to="/">{t.nav.home}</Link>
          <Link to="/about">{t.nav.about}</Link>
          <Link to="/ecosystem">{t.nav.ecosystem}</Link>
          <Link to="/team">{t.nav.team}</Link>
          <Link to="/technology">{t.nav.technology}</Link>
        </div>
        <div className="nav-right">
          <button className="nav-cta" onClick={() => {
            const footer = document.getElementById('footer');
            if (footer) footer.scrollIntoView({ behavior: 'smooth' });
          }}>
            {t.nav.contactUs}
          </button>
          <LanguageSwitcher />
          <div className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>
      <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'active' : ''}`} onClick={closeMobile}></div>
      <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
        <Link to="/" onClick={closeMobile}>{t.nav.home}</Link>
        <Link to="/about" onClick={closeMobile}>{t.nav.about}</Link>
        <Link to="/ecosystem" onClick={closeMobile}>{t.nav.ecosystem}</Link>
        <Link to="/team" onClick={closeMobile}>{t.nav.team}</Link>
        <Link to="/technology" onClick={closeMobile}>{t.nav.technology}</Link>
        <div className="mobile-lang">
          <LanguageSwitcher />
        </div>
      </div>
    </>
  );
};

export default Navbar;
